import {
	ClientPortfolioDomainEnum,
	type LoanDetailDataDTO,
} from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { EditLoansForm } from "web_myplann/Portfolio/Pages/LoansEdit/EditLoansForm";
import { PortfolioEditLayout } from "web_myplann/Portfolio/PortfolioShared/PortfolioEditLayout";

export const EditLoansPage = () => {
	const { t } = useResource();

	return (
		<PortfolioEditLayout
			expectedDomain={ClientPortfolioDomainEnum.Loans}
			title={t(Resources.Portfolio.EditPortfolio.title)}
		>
			{({ portfolio, portfolioId, detailRoute }) => (
				<EditLoansForm
					portfolioId={portfolioId}
					portfolio={portfolio}
					detailRoute={detailRoute}
					showFixation={Boolean(
						(portfolio.data as LoanDetailDataDTO | undefined)?.fixationEndDate,
					)}
				/>
			)}
		</PortfolioEditLayout>
	);
};
